import store from '../redux/store';
import { auth } from '../utils/auth';
import { AuthEventData, CustomEventType } from '../types/event';
import { AuthState, AuthStateLoginStatus } from '../types/auth';

declare global {
  interface Window {
    getAuthData: () => AuthEventData;
    getAuthToken: () => Promise<string | undefined>;
  }
}

const getAuthData = () => {
  const autState: AuthState = store.getState().auth;
  const identity = autState.authContext;
  const isLoading = autState.loginStatus === AuthStateLoginStatus.LOADING;
  const isAuthenticated = autState.loginStatus === AuthStateLoginStatus.AUTHENTICATED;

  const data: AuthEventData = {
    isLoading: isLoading,
    isAuthenticated: isAuthenticated,
    identity: identity,
  };

  return data;
};

export const initializeGloballyExposedAuthHelpers = () => {
  if (!window['getAuthData'] || !window['getAuthToken']) {
    window['getAuthData'] = () => getAuthData();
    window['getAuthToken'] = async () => auth.getToken();

    const event = new CustomEvent(CustomEventType.AUTH_HELPERS_INITIALIZED);
    document.dispatchEvent(event);
  }
};

export const dispatchAuthUpdatedEvent = () => {
  const event = new CustomEvent(CustomEventType.AUTH_UPDATED, {
    detail: getAuthData(),
  });
  document.dispatchEvent(event);
};
